module.exports = __webpack_public_path__ + "static/media/footballPromo.54cf37b6.png";